{
  "Home": "Home",
  "permits": {
    "permits": "Permits",
    "fulfillments": {
      "fulfillments": "fulfillments"
    },
    "inventory": {
      "inventory": "inventory"
    }
  },
  "citation": {
    "citation": "citation",
    "manageAppeals": "manage-appeals"
  },
  "reports": {
    "reports": "reports",
    "financialReports": "financial-reports",
    "orders": "reports-order",
    "citations": "reports-citations",
    "financials": "reports-financials",
    "inventory": "reports-inventory",
    "account": "reports-account"
  },
  "settings": {
    "settings": "Settings",
    "settings_permits": {
      "settingPermits": "settings-permits",
      "permitTypes": "permit-types",
      "permitTemplate": "permit-template",
      "permitBuyerAccess": "permit-buyer-access"
    },
    "settings_citations": {
      "settingCitations": "settings-citations",
      "citationTypes": "citation-types",
      "template": {
        "citetionsTemplate": "settings-citations-template"
      }
    },
    "settings_administration": {
      "settingsAdministration": "settings-administration",
      "driver_portal": {
        "driverPortal": "admin-driver-portal",
        "driver_home_page": "admin-home-page",
        "user_account": "admin-user-account",
        "sales_message": "admin-sales-message",
        "buyer_authorization": "admin-buyer-authorization",
        "citation": "admin-citation"
      },
      "templates": {
        "templates": "admin-templates"
      }
    },
    "settings_plugins": {
      "settingsPlugins": "settings-plugins"
    }
  },
  "help_features": {
    "helpFeature": "help-feature"
  },
  "driver_records": {
    "driverRecords": "driver-records"
  }
}
